var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68817 1.79558C5.82876 1.51331 6.11775 1.33502 6.43277 1.33502H9.5674C9.88243 1.33502 10.1714 1.51331 10.312 1.79558L10.4995 2.16815H12.9988C13.4597 2.16815 13.832 2.54123 13.832 3.00127C13.832 3.46131 13.4597 3.8344 12.9988 3.8344H3.00134C2.5413 3.8344 2.16821 3.46131 2.16821 3.00127C2.16821 2.54123 2.5413 2.16815 3.00134 2.16815H5.50071L5.68817 1.79558ZM12.4469 13.47C12.4052 14.1521 11.8611 14.665 11.1998 14.665H4.80037C4.14038 14.665 3.59416 14.1521 3.55302 13.47L2.97791 4.66752H12.9988L12.4469 13.47Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a74fdfc4a2a5ddbea70efa599dcca909.svg";
export { ForwardRef as ReactComponent };